const KEY_AUTH = 'mochi_auth';

class Storage {
  saveAuth = (obj) => {
    return localStorage.setItem(KEY_AUTH, JSON.stringify(obj));
  };

  getAuth = () => {
    if (this.isServer()) return;
    return this.parse(localStorage.getItem(KEY_AUTH));
  };

  clearAuth = () => {
    if (this.isServer()) return;

    return localStorage.removeItem(KEY_AUTH);
  };

  isServer = () => {
    return typeof window === 'undefined';
  };

  parse = (obj) => {
    try {
      return JSON.parse(obj);
    } catch (e) {
      return null;
    }
  };
}

export default new Storage();
